// decorators/operations.ts
import { registerOperation } from "../metadata/operations.js";
var Query = (type, options) => operationHelper(type, "query", options);
var Mutation = (type, options) => operationHelper(type, "mutation", options);
var Subscription = (type, options) => operationHelper(type, "subscription", options);
function operationHelper(type, opType, options) {
  return (target, propertyName, descriptor) => {
    descriptor.value = registerOperation({
      type,
      opType,
      entity: target,
      operationName: propertyName + "_prop",
      resolve: descriptor.value,
      options
    });
    return descriptor;
  };
}
export {
  Mutation,
  Query,
  Subscription
};
